<template>
    <el-upload style="text-align:center;"
               drag
               :headers="headers"
               :action="uploadActionUrl"
               :on-success="(response, file, fileList) => { handleSuccess(response, file, fileList) }"
               :before-remove="(file, fileList) => { handleRemove(file, fileList) }"
               :data="info"
               multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">选择文件后，文件自动上传。上传完成后关闭此窗口即可。</div>
        <div slot="tip" class="el-upload__tip" v-if="externalTip !== undefined && externalTip.length > 0">{{ externalTip }}</div>
    </el-upload>
</template>

<script>
    import store from '@/store';
    import { deleteAttachment } from "@/api/utils";
    export default {
        name: 'UploadFile',
        props: {
            uploadActionUrl: {
                type: String
            },
            externalTip: {
                type: String
            },
            Id: {
                type: String
            },
            tableName: {
                type: String
            }
        },
        created() {

        },
        data() {
            let infoStr = JSON.stringify({
                TableName: this.tableName === undefined || this.tableName == null ? '' : this.tableName,
                Id: this.Id === undefined || this.Id == null ? 0 : this.Id*1
            });
            return {
                info: {
                    "infos": infoStr
                },
                attachmentIds: []
            }
        },
        computed: {
            headers() {
                return {
                    "Authorization": "Bearer " + store.getters.token
                }
            },
        },
        methods: {
            handleSuccess(response, file, fileList) {
                if (response.Code === 1 && response.Data["AffectedRows"] !== "" && response.Data["AffectedRows"] !== "0"){
                    this.$emit('change', { name: 'uploadFile',ids: response.Data.ids });
                    let index = fileList.findIndex(x => x === file);
                    this.attachmentIds[index] = response.Data.ids[0];
                }
            },
            handleRemove(file, fileList){
                let index = fileList.findIndex(x => x === file);
                let id = this.attachmentIds[index];
                this.attachmentIds.splice(index, 1);
                deleteAttachment(id, this.Id === undefined || this.Id == null ? 0 : this.Id*1,
                    this.tableName === undefined || this.tableName == null ? '' : this.tableName);
            }
        }
    }
</script>

<style scoped>
</style>
